import React, { useEffect, useState, useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/material';
import HeaderProfile from '../../../../components/header_Profile/header_Profile.index';
import { useTranslation } from 'react-i18next';


const RefundDetails: React.FC = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { t: tBilling } = useTranslation('billing_config');
  const [selectedTab, setSelectedTab] = useState(0);
  const visibleTabs = useMemo(
    () => [
      { key: 'advance', label: tBilling('RefundDetails.tabs.advance', 'Advance'), route: 'advance' },
      { key: 'invoice', label: tBilling('RefundDetails.tabs.invoice', 'Invoice'), route: 'invoice' },
    ],
    [tBilling]
  );


  // Map routes to tab index (relative paths)
  const tabRoutes = useMemo(() => visibleTabs.map((t) => t.route), [visibleTabs]);


  useEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    const typeSegment = segments[segments.length - 2] || '';
    const tabIndex = tabRoutes.indexOf(typeSegment);
    setSelectedTab(tabIndex !== -1 ? tabIndex : 0);
  }, [location.pathname, tabRoutes]);
  
  const handleTabChange = (event: React.SyntheticEvent, newValue: number): void => {
    setSelectedTab(newValue);
    const segments = location.pathname.split('/').filter(Boolean);
    const currentRefundId = segments[segments.length - 1];
    navigate(`${tabRoutes[newValue]}/${currentRefundId}`); // relative to refund-Details/:id
  };
  

  const segments = location.pathname.split('/').filter(Boolean);
  const typeSegment = segments[segments.length - 2] || '';
  const showTabs = ['advance', 'invoice'].includes(typeSegment);

  return (
    <>
      <HeaderProfile />
      <Box data-testid="refund-details-container">
        {showTabs && (
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            centered
            variant='fullWidth'
            sx={{ mb: 2 }}
            TabIndicatorProps={{ style: { backgroundColor: '#E17E61' } }}
            data-testid="refund-details-tabs"
          >
            {visibleTabs.map((label, index) => {
              return (
                <Tab
                  key={label.key}
                  label={label.label}
                  sx={{
                    fontFamily: 'Montserrat',
                    fontSize: '16px',
                    fontWeight: selectedTab === index ? 600 : 500,
                    color: '#BBBBBB',
                    textTransform: 'none',
                    '&.Mui-selected': {
                      color: '#E17E61',
                      fontWeight: 600,
                    },
                  }} />
              );
            })}
          </Tabs>
        )}
        <Box overflow='auto'>
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default RefundDetails;
